import React, { useEffect, useRef } from 'react'

const AboutImages = () => {
  const sectionRef = useRef(null)
  const imagesRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active')
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    const elements = [sectionRef.current, imagesRef.current].filter(Boolean)
    elements.forEach(element => observer.observe(element))

    return () => {
      elements.forEach(element => observer.unobserve(element))
    }
  }, [])

  const aboutImages = [
    {
      src: "/about1.jpeg",
      alt: "Group workshop session with inspirational quote about transformation"
    },
    {
      src: "/about2.jpeg", 
      alt: "Two men in contemplative session with emotional processing quotes"
    },
    {
      src: "/about3.jpeg",
      alt: "Group writing and processing session with consciousness mapping"
    }
  ]

  return (
    <section className="about-images" ref={sectionRef}>
      <div className="container">
        {/* <div className="section-header">
          <h2>The Work We Do</h2>
          <p>Real transformation happens in the spaces between comfort and growth</p>
        </div> */}
        
        <div className="images-grid" ref={imagesRef}>
          {aboutImages.map((image, index) => (
            <div key={index} className="image-card">
              <div className="image-container">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="about-image"
                />
              </div>
            </div>
          ))}
        </div>
        
        {/* <div className="about-images-footer">
          <p className="footer-text">
            These moments capture the essence of our work together — creating safe spaces 
            for authentic human experience, where vulnerability becomes strength and 
            discomfort becomes the pathway to freedom.
          </p>
        </div> */}
      </div>
    </section>
  )
}

export default AboutImages
